
<template>
  <v-card class="pt-5 white text-xs-ceneter login-container" flat>
    <!-- <div class="text-xs-center mb-3">
      <img :src="branch_hrz_logo" style="max-width:380px;height:auto" />
    </div> -->

    <div class="text-xs-center">
      <img :src="branch_logo" class="branch-logo" />
    </div>
    <v-card-text class="text-xs-center title grey1--text font-weight-bold mb-3">
      <div>{{ LONG_APP_NAME }}</div>
      <div class="pt-3">{{ branch_fa_name }}</div>
    </v-card-text>
    <v-layout row wrap px-4 py-0>
      <v-text-field
        type="email"
        :label="$t('email')"
        v-model="email"
        class="flex xs12"
        @keyup.enter="login"
        sprepend-icon="email"
        data-vv-name="email"
        @input="correct = true"
        :data-vv-as="$t('email')"
        v-validate="'required|email'"
        :error-messages="errors.collect('email')"
      />
      <v-text-field
        v-model="pass"
        class="flex xs12"
        @keyup.enter="login"
        :label="$t('password')"
        @input="correct = true"
        v-validate="'required'"
        data-vv-name="password"
        :data-vv-as="$t('password')"
        @click:append="show1 = !show1"
        :type="show1 ? 'text' : 'password'"
        :error-messages="errors.collect('password')"
        :append-icon="show1 ? 'visibility' : 'visibility_off'"
      />
      <v-flex class="px-5 pt-2 mt-4">
        <v-btn
          color="primary"
          block
          :disabled="loading"
          :loading="loading"
          @click="login"
        >
          <span>{{ $t("login") }}</span>
        </v-btn>
      </v-flex>
      <!-- <div class="flex xs12 flex-row mt-4">
        <a href="/auth/password-reset" class="body-2 info--text">{{
          $t("forgot_password")
        }}</a>
      </div> -->
    </v-layout>
    <v-card-actions
      v-if="authStatus == 'error'"
      class="grey lighten-3 mt-5 py-1 mb-0"
    >
      <span class="error--text f_12 py-1 flex xs12 text-xs-center">
        {{ error }}
      </span>
    </v-card-actions>
  </v-card>
</template>


<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      pass: "",
      email: "",
      error: "",
      show1: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters("AuthModule", { authStatus: "authStatus" }),
  },
  methods: {
    login() {
      let vm = this;
      this.loading = true;
      this.$validator.validateAll().then((result) => {
        if (result) {
          const { email, pass } = this;
          this.$store
            .dispatch("AuthModule/AUTH_REQUEST", { email, pass })
            .then((res) => {
              setTimeout(() => {
                this.$router.push("/");
              }, 1000);
              this.loading = false;
            })
            .catch((err) => {
              this.loading = false;
              this.error = err.response.data.data;
            });
        } else {
          this.loading = false;
        }
      });
    },
  },
};
</script>
<style scoped>
.login-container {
  max-width: 450px;
  padding: 0 10px;
}

.branch-logo {
  width: 100px;
  height: auto;
}
</style>